import {
  Box,
  Button,
  Card,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  SvgIcon,
  Typography,
} from "@mui/material";
import { capitalCase } from "change-case";
import { useSnackbar } from "notistack";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Iconify } from "src/components";

function PricingPlansCard({ activePlans = [], handleCancelSubscription }) {
  const navigate = useNavigate();
  console.log(activePlans, "Active_Plans");
  const { enqueueSnackbar } = useSnackbar();

  const handleButtonClick = (plan) => {
    console.log(plan, "plaans");
    navigate(`/plan-detail/${plan?._id}`, { state: plan?._id });
  };

  return (
    <>
      <div className="container pt-2 pb-5">
        <div className="card">
          <div className="row justify-content-center">
            {activePlans.map((plan) => (
              <div className="col-12 col-md-6 col-lg-4 col-xl-3 d-flex align-items-end position-relative plans-card">
                {/* <Card
                  className={`p-3`}
                  sx={{
                    height: "100%",
                    border: "0.15rem solid",
                    width: "100%",
                    borderColor: (theme) => theme.palette.primary.main,
                  }}
                >
                  {plan?.is_active && (
                    <div
                      style={{
                        height: "30px",
                        backgroundColor: "#00AB55",
                        margin: "-16px -17px 16px",
                        textAlign: "center",
                        color: "#fff",
                      }}
                    >
                      <p className="pt-1">Active Plan</p>
                    </div>
                  )}
                  <div className="">
                    <div className="h3-style">
                      <div className="wb-editor-block  mt-2">
                        <h4>{plan.name}</h4>
                      </div>
                    </div>
                    <div className="row">
                      <div
                        className="d-flex pt-2"
                        style={{
                          color: (theme) => theme.palette.primary.main,
                          alignItems: "center",
                        }}
                      >
                        <h4
                          style={{
                            fontStyle: "32px",
                            fontWeight: "initial",
                          }}
                        >
                          {plan.currency_symbol}
                        </h4>{" "}
                        <h4
                          style={{
                            fontStyle: "32px",
                            fontWeight: "initial",
                          }}
                        >
                          {plan.price}
                        </h4>{" "}
                        <span
                          className="ps-1"
                          style={{ fontWeight: "bold", color: "gray" }}
                        >
                          {" "}
                          /{plan.plan_type}
                        </span>
                      </div>
                    </div>
                    <div>
                      <p className="pt-2">{plan?.short_description}</p>
                    </div>

                    <div>
                      <Button
                        onClick={() => {
                          handleButtonClick(plan);
                        }}
                        fullWidth
                        variant="contained"
                        className="my-2"
                        disabled={plan?.is_active === true}
                      >
                        GET STARTED
                        <i className="fa-solid fa-arrow-right ms-2"></i>
                      </Button>
                    </div>
                    <div className="mt-3">
                      <p
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                        }}
                      >
                        {` ${plan.name} 
                        Includes:`}
                      </p>
                    </div>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: plan?.detailed_description,
                      }}
                    ></div>
                  </div>
                </Card> */}
                <Paper
                  elevation={3}
                  sx={{
                    borderRadius: "16px",
                    width: "100%",
                    height: "100%",
                    p: "6px",
                    border: plan?.is_active ? "2px dashed #00ab55" : "",
                  }}
                >
                  <Box
                    className="pricing-box"
                    sx={{
                      backgroundColor: plan?.is_active ? "#f0f0f0" : "#ffffff",
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box
                      className="pricing-badge"
                      sx={{
                        backgroundColor: plan?.is_active
                          ? "#00ab55"
                          : "#f0f0f0",
                      }}
                    >
                      {plan?.is_active ? (
                        <Typography
                          component="span"
                          sx={{
                            fontSize: "0.75",
                            fontWeight: 600,
                            color: "white",
                          }}
                        >
                          Active Plan
                          <span style={{ fontSize: "12px" }}>
                            {" "}
                            {plan?.currency_symbol} {plan?.price}/{" "}
                            {capitalCase(plan?.plan_type)}
                          </span>
                        </Typography>
                      ) : (
                        <>
                          {plan?.currency_symbol} {plan?.price}
                          <Typography
                            component="small"
                            sx={{
                              fontSize: "0.875em",
                              color: "#707a91",
                              fontWeight: "500",
                              ml: 0.5,
                            }}
                          >
                            / {capitalCase(plan?.plan_type)}
                          </Typography>
                        </>
                      )}
                    </Box>

                    <Typography variant="h5" sx={{ fontWeight: 600 }}>
                      {capitalCase(plan?.name)}
                    </Typography>

                    <Typography variant="body2" sx={{ mt: 1 }}>
                      {plan?.short_description}
                    </Typography>

                    <Divider
                      sx={{ width: "100%", m: "12px 0px", borderColor: "gray" }}
                    />

                    <Box sx={{ flexGrow: 1 }}>
                      <Typography sx={{ fontSize: "13px", fontWeight: 600 }}>
                        {`${capitalCase(plan?.name)} Includes:`}
                      </Typography>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: plan?.detailed_description,
                        }}
                      ></div>
                    </Box>

                    <Box mt={"10px"}>
                      {plan?.is_active === true ? (
                        <Button
                          fullWidth
                          variant="outlined"
                          color="error"
                          onClick={handleCancelSubscription}
                          sx={{
                            fontWeight: 500,
                            fontSize: "0.8rem",
                          }}
                        >
                          Cancel Subscription
                        </Button>
                      ) : (
                        <Button
                          fullWidth
                          variant="contained"
                          endIcon={<Iconify icon="si:arrow-right-fill" />}
                          onClick={() => handleButtonClick(plan)}
                          disabled={plan?.is_active === true}
                          sx={{
                            fontWeight: 500,
                            fontSize: "0.8rem",
                          }}
                        >
                          get started
                        </Button>
                      )}
                    </Box>
                  </Box>
                </Paper>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default PricingPlansCard;
